<script>
import "@/scss/dashboard/_dashboardNew.scss";
import config from "@/config";
import { pickSvg } from "@/SVG";
import { getTransaction } from "@/methods/payModule";

const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();

export default {
  components: {
    ...pickSvg(
      "solidDirection",
      "arrowrightSVG",
      "rightArrowCircleSVG",
      "leftArrowCircleSVG",
      "starOutlineSVG",
      "rightArrowCircleSolidSVG",
      "leftArrowCircleSolidSVG",
      "patientleftarrowSVG",
      "patientrightarrowSVG",
      "periodSVG",
      "cardioSVG",
      "hairfallSVG",
      "abdomenSVG",
      "backpainSVG",
      "depressionSVG",
      "aciditygasSvg"
    )
  },
  data() {
    return {
      slotTab: "adults",
      dayJS,
      transactionStatus: false
    };
  },
  methods: {
    bookOnlineConsultation() {
      window.location.href = `${config.NUXT_URL}doctor-search?filter=online-consultation`;
    },
    searchPharmacy(filter) {
      window.location.href = `${config.NUXT_URL}pharmacy-search?${filter ? this.encodeQueryData(filter) : ''}`;
    },
    routeToMedicineSearch() {
      window.location.href = `${config.NUXT_URL}medicine-search`;
    },
    healthPackageSearch() {
      window.location.href = `${config.NUXT_URL}health-package/health-package-search`;
    },
    bookTest(filter) {
      window.location.href = `${config.NUXT_URL}diagnostic-search?${filter ? this.encodeQueryData(filter) : ''}`;
    },
    bloodBankSearch(filter) {
      window.location.href = `${config.NUXT_URL}blood-bank-search?${filter ? this.encodeQueryData(filter) : ''}`;
    },
    ambulanceSearch(filter) {
      window.location.href = `${config.NUXT_URL}ambulance-search?${filter ? this.encodeQueryData(filter) : ''}`;
    },
    hospitalSearch(filter) {
      window.location.href = `${config.NUXT_URL}hospital-search?${filter ? this.encodeQueryData(filter) : ''}`;
    },
    doctorSearch(filter) {
      window.location.href = `${
        config.NUXT_URL
      }doctor-search?${filter ? this.encodeQueryData(filter) : ''}`;
    },
    alliedSearch(filter) {
      window.location.href = `${
        config.NUXT_URL
      }allied-search?${filter ? this.encodeQueryData(filter) : ''}`;
    },
    encodeQueryData(data) {
      const ret = [];
      for (let d in data)
        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
      return ret.join("&");
    },
    upcomindAppointmentsSlider(tabNo) {
      if (tabNo === "tab-1") {
        document.getElementById("upcomingAppointments").scrollLeft -= 800;
        this.leftActive = true;
        this.rightActive = false;
      } else if (tabNo === "tab-2") {
        document.getElementById("upcomingAppointments").scrollLeft += 800;
        this.leftActive = false;
        this.rightActive = true;
      }
    },
    yourOrdersSlider(tabNo) {
      if (tabNo === "tab-1") {
        document.getElementById("yourOrders").scrollLeft -= 800;
        this.leftActive = true;
        this.rightActive = false;
      } else if (tabNo === "tab-2") {
        document.getElementById("yourOrders").scrollLeft += 800;
        this.leftActive = false;
        this.rightActive = true;
      }
    },
    blogsSlider(tabNo) {
      if (tabNo === "tab-1") {
        document.getElementById("blogs").scrollLeft -= 800;
        this.leftActive = true;
        this.rightActive = false;
      } else if (tabNo === "tab-2") {
        document.getElementById("blogs").scrollLeft += 800;
        this.leftActive = false;
        this.rightActive = true;
      }
    },
    newblogsSlider(tabNo) {
      if (tabNo === "tab-1") {
        document.getElementById("newblogs").scrollLeft -= 800;
        this.leftActive = true;
        this.rightActive = false;
      } else if (tabNo === "tab-2") {
        document.getElementById("newblogs").scrollLeft += 800;
        this.leftActive = false;
        this.rightActive = true;
      }
    },
    eventsSlider(tabNo) {
      if (tabNo === "tab-1") {
        document.getElementById("events").scrollLeft -= 800;
        this.leftActive = true;
        this.rightActive = false;
      } else if (tabNo === "tab-2") {
        document.getElementById("events").scrollLeft += 800;
        this.leftActive = false;
        this.rightActive = true;
      }
    },
    getPendingHomeVisits() {
      const params = Object.assign(
        {},
        {
          page: 1,
          records: 5,
          status_type: "Pending",
          get_allied:true
        }
      );
      return new Promise((resolve, reject) => {
        const url = `${config.NEW_BASE_URL}api/v2/calendar-events/doctor/appointments/patient`;
        this.$http
          .post(url, params)
          .then(response => {
            const { body } = response;
            if (body.status) {
              resolve(body.data.list);
            }
          })
          .catch(err => reject(err));
      });
    },
    getUpcomingBookings() {
      const params = Object.assign(
        {},
        {
          page: 1,
          records: 5,
          status_type: "All",
          get_allied:true
        }
      );
      return new Promise((resolve, reject) => {
        const url = `${config.NEW_BASE_URL}api/v2/calendar-events/doctor/appointments/patient`;
        this.$http
          .post(url, params)
          .then(response => {
            const { body } = response;
            if (body.status) {
              resolve(body.data.list);
            }
          })
          .catch(err => reject(err));
      });
    },
    getPendingDiagnosticsBookings() {
      const params = Object.assign(
        {},
        {
          page: 1,
          records_per_page: 5,
          status: "upcoming",
          center_name: "",
        }
      );
      return new Promise((resolve, reject) => {
        const url = `${config.DIAGNOSTICS_URL}api/v1/patient/booking-details-bystatus`;
        this.$http
          .get(url, { params })
          .then(response => {
            const { body } = response;
            if (body.status) {
              resolve(body.data.data);
            }
          })
          .catch(err => reject(err));
      });
    },
    getPendingAmbulanceBookings() {
      const params = Object.assign(
        {},
        {
          page: 1,
          records_per_page: 5,
          status: "accepted",
          search_text: "",
          gte_search_date: dayJS().format("DD/MM/YYYY"),
        }
      );
      return new Promise((resolve, reject) => {
        const url = `${config.AMBULANCE_URL}api/v1/booking/patient/list`;
        this.$http
          .get(url, { params })
          .then(response => {
            const { body } = response;
            if (body.status) {
              resolve(body.data.list);
            }
          })
          .catch(err => reject(err));
      });
    },
    getBloodbankPendingOrders() {
      const url = `${config.BLOODBANK_URL}api/v1/order`;
      const params = {
        page: 1,
        status: "ACCEPTED",
        date: new Date(),
      };

      return new Promise((resolve, reject) => {
        this.$http
          .get(url, { params })
          .then(response => {
            response = response.body;
            if (response.status) resolve(response.data.list);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getPharmacyPendingOrders() {
      const params = Object.assign(
        {},
        {
          page: 1,
          status: "accepted",
          date: dayJS().format("YYYY-MM-DD")
        }
      );
      return new Promise((resolve, reject) => {
        const url = `${config.PHARMACY_URL}api/v1/patient/orders`;
        this.$http
          .get(url, { params })
          .then(response => {
            const { body } = response;
            if (body.status) {
              resolve(body.data.data);
            }
          })
          .catch(err => reject(err));
      });
    },
    redirectToPending(role) {
      switch (role) {
        case "doctor":
          this.$router.push("/patient/appointments/doctors");
          break;
        case "ambulance":
          this.$router.push("/patient/appointments/ambulance");
          break;
        case "bloodbank":
          this.$router.push("/patient/myOrders/bloodbank");
          break;
        case "pharmacy":
          this.$router.push("/patient/myOrders/pharmacy");
          break;
        case "diagnostics-lab":
          this.$router.push("/patient/appointments/diagnostics");
          break;
      }
    },
    async getTransactionStatus(transaction_id) {
      try {
        const transaction = await getTransaction(this, transaction_id);
        this.transactionStatus = transaction.status === "paid";
      } catch (error) {
        this.transactionStatus = false;
      }
    }
  },
  filters: {
    currency(value) {
      return new Intl.NumberFormat("en-IN").format(value || 0);
    },
    formatDate(value) {
      return dayJS(value).format("DD/MM/YYYY");
    },
    trimDescription(value) {
      return (
        value
          .split(" ")
          .slice(0, 2)
          .join(" ") + "..."
      );
    },
    stripHtml(value) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = value;
      return tmp.textContent || tmp.innerText || "";
    },
    formatDateTime(value) {
      return dayJS(value).format("DD/MM/YYYY hh:mm A");
    },
    formatTime(value) {
      return dayJS(value).format("hh:mm A");
    },
  }
};
</script>
